import React from "react";

export function RenderAvatarImageForBenefPortal({
  name,
  avatar,

  avatarContainerStyling,
}) {
  let initials = "";
  name.split(" ")?.map((n) => (initials = initials + n[0]));
  let extension;
  avatar && (extension = avatar[0]);
  if (extension === "/") extension = ".jpg";
  else if (extension === "i") extension = ".png";
  let avatarStyling = {};
  if (!avatar) {
    avatarStyling.backgroundColor = "#023E8A";
  }
  if (avatarContainerStyling) {
    avatarStyling = { ...avatarContainerStyling, ...avatarStyling };
  }

  return (
    <div
      title={name}
      style={{
        borderRadius: "50%",
        width: "100px",
        height: "100px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "16px",
        fontWeight: "500",
        color: "#ebf4f9",
        boxShadow: "1px 3px 3px 1px rgba(0, 0, 0, 0.2)",
        textTransform: "uppercase",
        marginBottom: "5px",
        ...avatarStyling,
      }}
    >
      {avatar ? (
        <img
          style={{
            width: "100%",
            height: "100%",
            borderRadius: "50%",
          }}
          src={`data:image/${extension};base64,${avatar}`}
          alt="avatar"
        />
      ) : (
        <span
          style={{
            overflow: "hidden",
            textWrap: "nowrap",
          }}
        >
          {/* {initials.slice(0, 7)} */}
          {initials.length > 4 ? <>{initials.slice(0, 4)}...</> : initials}
        </span>
      )}
    </div>
  );
}
